import { render } from "./SignWrapPeercoin.vue?vue&type=template&id=7725ca76&scoped=true"
import script from "./SignWrapPeercoin.vue?vue&type=script&lang=js"
export * from "./SignWrapPeercoin.vue?vue&type=script&lang=js"

import "./SignWrapPeercoin.vue?vue&type=style&index=0&id=7725ca76&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7725ca76"

export default script